import { type Common } from '../../common.js';
import {
  type PaginatedQueryOptions,
  type PaginationResponse,
} from '../../models/pagination/index.js';
import {
  type CreateValues,
  type EditResponse,
  type FindAllOptions,
  type TestOrderPopulated,
  type UpdateValues,
} from '../../models/workflowTest/entity/order.js';

export default class API {
  common: Common;
  baseEndpoint = '/workflow-test/entity/order';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options?: FindAllOptions): Promise<TestOrderPopulated[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<TestOrderPopulated>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(orderId: string): Promise<EditResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${orderId}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<EditResponse> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async clone(orderId: string): Promise<EditResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${orderId}/clone`);
    return await this.common.postJSON(url, {});
  }

  async update(orderId: string, values: UpdateValues): Promise<EditResponse> {
    if (typeof values.order.followUpValue !== 'number') {
      values.order.followUpValue = null;
    }
    const url = this.common.constructPath(`${this.baseEndpoint}/${orderId}`);
    return await this.common.patchJSON(url, values);
  }
}
